let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6ks1u")).then(() => parcelRequire('8zM2d'));